import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import qs from 'qs';

async function fetchTopOrganisations({ queryKey }) {
  const [, params] = queryKey;

  const queryParams = qs.stringify(params);

  const url = params.firmId
    ? `dashboard/top-organisations/?${queryParams}`
    : `dashboard/top-organisations`;

  const { data } = await api.get(url);

  return data.data;
}

function useTopOrganisations({ params }) {
  return useQuery({
    queryKey: ['dashboard-top-organisations', params],
    queryFn: fetchTopOrganisations,
    placeholderData: keepPreviousData,
    staleTime: 4 * 60 * 60 * 1000,
  });
}

export default useTopOrganisations;
